import type { Site } from '@/features/branding/brand-provider';
import { LocationStats } from '@/features/dashboard/components/location-dashboard';
import { PortfolioStats } from '@/features/dashboard/components/portfolio-dashboard';

/** The admin dashboard: per-location view, or totals for a portfolio. */
export default function Stats({
  site,
  locations,
}: {
  site: Site;
  locations: { id: number; name: string }[];
}) {
  return site.siteType === 'portfolio' ? (
    <PortfolioStats site={site} locations={locations} />
  ) : (
    <LocationStats site={site} />
  );
}
